import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function FaultCodes() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));

    const data = [
        { system: "Alpha", code: "A100", id: "001", dateTime: "2025-03-05 10:15 AM", occurrences: 3, info: "Info" },
        { system: "Beta", code: "B200", id: "002", dateTime: "2025-03-05 11:30 AM", occurrences: 5, info: "Info" },
        { system: "Gamma", code: "C300", id: "003", dateTime: "2025-03-05 12:45 PM", occurrences: 2, info: "Info" },
        { system: "Delta", code: "D400", id: "004", dateTime: "2025-03-05 01:00 PM", occurrences: 7, info: "Info" },
    ];

    const columns = [
        { name: "System", selector: (row) => row.system, sortable: true },
        { name: "Code", selector: (row) => row.code, sortable: true },
        { name: "ID", selector: (row) => row.id, sortable: true },
        { name: "Date & Time", selector: (row) => row.dateTime, sortable: true },
        { name: "Occurrences", selector: (row) => row.occurrences, sortable: true },
        { name: "Info", selector: (row) => row.info, sortable: true },
    ];

     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Fault Codes </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Fault Codes</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
